/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Tarjeta_Mision_Vision_Informacion from "./Tarjetas/Tarjeta_Mision_Vision_Informacion";
import mision from "../../../Recursos/mision.png";
import vision from "../../../Recursos/vision.png";


const Mision_Vision_Informacion = () => {

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}>

            <Grid2 container
                   spacing={18}
                   size={12}
                   sx={{maxWidth: '1400px', px: 3}} justifyContent={'center'}>

                <Grid2 container size={{xs: 12, sm: 12, md: 11}}>

                    {items.map((item, index) => (
                        <Grid2 container size={12}>
                            <Tarjeta_Mision_Vision_Informacion
                                titulo={item.titulo}
                                imagen={item.imagen}
                                parrafo={item.parrafo}
                            />
                        </Grid2>

                    ))}

                </Grid2>

            </Grid2>


        </Grid2>
    )

}
export default Mision_Vision_Informacion;

const items = [
    {
        imagen: mision,
        titulo: 'Misión',
        parrafo: 'En Fundhap, trabajan para garantizar el desarrollo integral, la inclusión social y el bienestar emocional de niños, jóvenes y adultos en situación de vulnerabilidad. Su enfoque se centra en potenciar las habilidades individuales y colectivas a través de programas innovadores que promueven la equidad y la autonomía, transformando positivamente el entorno social y familiar.'
    },
    {
        imagen: vision,
        titulo: 'Visión',
        parrafo: 'Para el año 2030, la fundación aspira a consolidarse como una organización referente a nivel nacional e internacional en procesos de transformación social e inclusión. Se proyectan liderando iniciativas que integren la neurociencia, la pedagogía y la sostenibilidad, contribuyendo de manera significativa al cumplimiento de los Objetivos de Desarrollo Sostenible (ODS) y construyendo un futuro donde la diversidad sea el motor del progreso.'
    }
]